// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"6dac3dfe","709":"ca69145b"}[chunkId] + ".chunk.js";
};